import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'redux-bundler-react'
import { Navbar, Nav, NavDropdown, Container, OverlayTrigger, Popover} from 'react-bootstrap'
import Switch from 'react-switch'
import { IoAlertCircle } from 'react-icons/io5'
import { BsGearFill,BsTrash,BsChevronDown,BsChevronRight } from 'react-icons/bs'
import GeneList from './results/GeneList'
import TaxDist from './results/TaxDist'
import HelpDemo from './results/HelpDemo'
import GeneAttribs from './results/GeneAttribs'
import TaxonomyModal from './TaxonomyModal'
import Expression from './results/Expression'
import UserGeneLists from './results/UserGeneLists'
import ExporterView from './exporter/ExporterView'
import ExprVizView from './exprViz/ExprVizView'
import AttrTableView from './attrTable/AttrTableView'
import OntologyEnrichment from './results/OntologyEnrichment'
import TaxDistTbrowse from './results/TaxDistTbrowse'
import Facets from './facets/FacetCounts'
import { EXPANSIONS, expansionType, expansionLabel, safeClassName, editorKindFor } from '../bundles/filters'
import GenomicIntervalForm from './GenomicIntervalForm'
import FilterEditor from './FilterEditor'
import Auth from './Auth'
import ReactGA from 'react-ga4'
import './styles.css';

const CollapsibleSection = ({ title, defaultOpen = true, extra, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="sidebar-section">
      <div className="sidebar-section-header" onClick={() => setOpen(!open)}>
        <b>{title}</b>
        <span className="sidebar-section-actions">
          {extra}
          <span className="sidebar-section-toggle">
            {open ? <BsChevronDown/> : <BsChevronRight/>}
          </span>
        </span>
      </div>
      {open && <div className="sidebar-section-body">{children}</div>}
    </div>
  );
};

const inventory = {
  help: HelpDemo,
  list: GeneList,
  taxonomy: TaxDist,
  taxTree: TaxDistTbrowse,
  attribs: GeneAttribs,
  expression: Expression,
  exprViz: ExprVizView,
  attrTable: AttrTableView,
  ontologyEnrichment: OntologyEnrichment,
  userLists: UserGeneLists,
  export: ExporterView
};

const StatusCmp = props => {
  let content = props.grameneFiltersStatus;
  // if (props.grameneFiltersStatus === 'init') {
  //   props.doClearGrameneFilters();
  // }
  if (props.grameneFiltersStatus === 'ready') {
    let tally = <span>Ready</span>;
    if (props.grameneSearch) {
      let genes = props.grameneSearch.response.numFound;
      let genomes = props.grameneSearch.facet_counts.facet_fields.taxon_id.length / 2;
      tally = <span><b>{genes}</b> genes in <b>{genomes}</b> genomes</span>;
    }
    const popover = (
      <Popover>
        <Popover.Header as="h3">Genomes Filter</Popover.Header>
        <Popover.Body>Searching {props.activeGenomeCount} genomes</Popover.Body>
      </Popover>
    );

    content = <span>
      {tally}
      <OverlayTrigger placement="auto" overlay={popover}>
        <span style={{float:'right', cursor:'pointer'}} onClick={props.doShowGrameneGenomes}><BsGearFill/></span>
      </OverlayTrigger>
      <TaxonomyModal/>
    </span>;
  }
  return <div style={{padding:'5px', color:'cornsilk', fontSize:'small'}}>{content}</div>
};

const Status = connect(
  'selectGrameneSearch',
  'selectGrameneFiltersStatus',
  'selectActiveGenomeCount',
  'doShowGrameneGenomes',
  'doClearGrameneFilters',
  StatusCmp
);

const handleClick = (e, moveCopyMode, showMarked, node, actions) => {
  if (!e) e = window.event;
  e.cancelBubble = true;
  if (e.stopPropagation) e.stopPropagation();

  if (showMarked && moveCopyMode) {
    if (node.marked) {
      actions.selectTarget(node);
    }
    else {
      actions.unmarkTargets()
    }
  }
  console.log(node, showMarked);
};
function logAction(action) {
  ReactGA.event({
    category: 'Search',
    action: action
  })
}
const Filter = ({node,moveCopyMode,showMarked,actions}) => {
  const [editing, setEditing] = useState(false);
  let classes = 'gramene-filter gramene-filter';
  if (node.operation) {
    classes = `${classes}-${safeClassName(node.operation)}`
  }
  // An expansion decorates whatever node it sits on, leaf or group — same as negate.
  const expType = expansionType(node);
  if (expType) {
    classes = `${classes} gramene-filter-EXPAND gramene-filter-EXPAND-${safeClassName(expType)}`
  }
  if (node.negate) {
    classes = `${classes} gramene-filter-NOT`
  }
  if (showMarked && node.marked) {
    classes = `${classes} gramene-filter-marked`
  }
  let content = '';
  let menu = '';
  let children = [];

  if (node.showMenu) {
    let key=1;
    let menuItems = [];
    if (node.hasOwnProperty('operation')) {
      menuItems.push(<li key={key++} onClick={()=>{logAction(`Change to ${node.operation}`); actions.changeOperation(node)}}>convert to <i>{node.operation === 'AND' ? 'OR' : 'AND'}</i></li>);
    }
    // A node carries at most one expansion, so the types are radios rather than
    // separate commands. Any node can carry one, leaf or group — attaching it to a
    // group means "expand whatever this group matches".
    menuItems.push(
      <li key={key++} className='gramene-filter-menu-label'>expand search</li>
    );
    Object.keys(EXPANSIONS).forEach(type => {
      const checked = expType === type;
      menuItems.push(
        <li key={key++} className='gramene-filter-menu-radio'
            onClick={()=>{
              // Re-picking the active type clears it — the only way to remove an
              // expansion from the root, which has no `delete`.
              if (checked) { logAction(`Remove expansion`); actions.removeExpansion(node); }
              else { logAction(`Expand by ${type}`); actions.expand(node, type); }
            }}>
          <input type='radio' readOnly checked={checked} onChange={()=>{}}
                 name={`gramene-expand-${node.leftIdx}`}/>
          {EXPANSIONS[type].label}
        </li>
      );
    });
    if (editorKindFor(node)) {
      menuItems.push(<li key={key++} onClick={()=>{logAction(`Edit filter`); actions.toggleMenu(node); setEditing(true)}}>edit</li>);
    }
    if (node.leftIdx > 0) {
      menuItems.push(<li key={key++} onClick={()=>{logAction(`Delete filter`); actions.deleteNode(node)}}>delete</li>);
      menuItems.push(<li key={key++} onClick={()=>{logAction(`Move filter`); actions.markTargets(node,'move')}}>move{node.isSource && ' select destination'}</li>);
      menuItems.push(<li key={key++} onClick={()=>{logAction(`Copy filter`); actions.markTargets(node,'copy')}}>copy{node.isSource && ' select destination'}</li>)
    }
    menuItems.push(<li key={key++} onClick={()=>{logAction(`Negate filter`); actions.negate(node)}}>negate</li>);
    menu = <div className='gramene-filter-menu'><ul>{menuItems}</ul></div>;
  }
  let warning;
  if (node.warning) {
    const popover = (
      <Popover>
        <Popover.Header as="h3">Warning</Popover.Header>
        <Popover.Body>{node.warning}</Popover.Body>
      </Popover>
    );
    warning = (
      <OverlayTrigger placement="auto" overlay={popover}><span style={{float:'right', color:'red', cursor:'pointer'}}><IoAlertCircle/></span></OverlayTrigger>
    )
  }
  // Shown above the node's own label, since the expansion applies to whatever that
  // node resolves to rather than replacing it.
  const expBadge = expType
    ? <span className='gramene-filter-expansion'
            onClick={()=>actions.toggleMenu(node)}>{expansionLabel(node)}</span>
    : null;
  if (node.operation) {
    children = node.children.map((child,idx) => <Filter key={idx} moveCopyMode={moveCopyMode} node={child} showMarked={showMarked} actions={actions}/>);
    content = (
      <div>
        {expBadge}
        <span className='gramene-filter-operation'
              onClick={()=>actions.toggleMenu(node)}>{node.operation}</span>
        {warning}
      </div>
    );
  }
  else {
    content = (
      <>
        {expBadge}
        <span className='gramene-filter-text'
              onClick={()=>actions.toggleMenu(node)}>{node.category} |&nbsp;{node.name}</span>
      </>
    );
  }
  const editor = editing ? (
    <FilterEditor node={node}
                  grameneMaps={actions.grameneMaps}
                  targetTaxonId={actions.targetTaxonId}
                  onCancel={()=>setEditing(false)}
                  onSave={(fq_value, name)=>{ setEditing(false); actions.editNode(node, fq_value, name); }}/>
  ) : null;
  return (
    <div key={node.leftIdx} className={classes} onClick={(e)=>handleClick(e,moveCopyMode, showMarked,node,actions)}>
      {content}{menu}{editor}{children}
    </div>
  )
};

const FiltersCmp = props => {
  const actions = {
    negate: props.doNegateGrameneFilter,
    deleteNode: props.doDeleteGrameneFilter,
    changeOperation: props.doChangeGrameneFilterOperation,
    expand: props.doExpandGrameneFilter,
    removeExpansion: props.doRemoveGrameneExpansion,
    selectTarget: props.doMoveOrCopyGrameneFilter,
    markTargets: props.doMarkGrameneFilterTargets,
    unmarkTargets: props.doUnmarkGrameneFilterTargets,
    toggleMenu: props.doToggleGrameneFilterMenu,
    editNode: props.doEditGrameneFilter,
    // Carried alongside the actions so every nested Filter can reach them without
    // threading two more props through the recursion.
    grameneMaps: props.grameneMaps,
    targetTaxonId: props.targetTaxonId
  };
  const intervalForm = (
    <GenomicIntervalForm grameneMaps={props.grameneMaps}
                         targetTaxonId={props.targetTaxonId}
                         onAdd={props.doAddGrameneInterval}/>
  );
  const containerClass = props.configuration.id === 'sorghum' ? 'sorghumbase-filter-container': 'gramene-filter-container';
  if (props.grameneFilters.rightIdx > 1) {
    return <div className={containerClass}>
      <CollapsibleSection title="Filters"
        extra={<span style={{cursor:'pointer', marginRight:'0.5rem'}} onClick={(e)=>{e.stopPropagation(); props.doClearGrameneFilters()}}><BsTrash/></span>}>
        <Filter node={props.grameneFilters}
                     moveCopyMode={props.grameneFilters.moveCopyMode}
                     showMarked={props.grameneFilters.showMarked}
                     actions={actions}/>
        {intervalForm}
      </CollapsibleSection>
    </div>
  }
  else {
    return <div className={containerClass}>
      <CollapsibleSection title="Filters">
        <div className='gramene-filter gramene-filter-AND'>No filters defined</div>
        {intervalForm}
      </CollapsibleSection>
    </div>
  }
};

const Filters = connect(
  'selectGrameneFilters',
  'selectConfiguration',
  'doNegateGrameneFilter',
  'doDeleteGrameneFilter',
  'doChangeGrameneFilterOperation',
  'doExpandGrameneFilter',
  'doRemoveGrameneExpansion',
  'doMoveOrCopyGrameneFilter',
  'doMarkGrameneFilterTargets',
  'doUnmarkGrameneFilterTargets',
  'doToggleGrameneFilterMenu',
  'selectGrameneMaps',
  'selectTargetTaxonId',
  'doAddGrameneInterval',
  'doEditGrameneFilter',
  'doClearGrameneFilters',
  FiltersCmp
);

const ResultsCmp = props => {
  let activeViews = props.grameneViews.options;
  return props.grameneFilters.rightIdx > 0 ? (
    <div>
      {activeViews.map((v,idx) => {
        let p = Object.assign({}, props);
        const divRef = useRef(null);
        useEffect(() => {
          if (v.shouldScroll) {
            const el = divRef.current;
            if (el) {
              // Scroll ONLY the results' own scroll container to this view. The
              // sidebar and results scroll independently in the sorghumbase app
              // shell, and el.scrollIntoView can walk every scrollable ancestor
              // (nudging the sidebar too), so instead find the results pane and
              // scroll just that. Fall back to the window when the results
              // aren't in a dedicated scroll pane (other layouts / mobile).
              let pane = el.parentElement;
              while (pane) {
                const oy = window.getComputedStyle(pane).overflowY;
                if ((oy === 'auto' || oy === 'scroll') && pane.scrollHeight > pane.clientHeight) break;
                pane = pane.parentElement;
              }
              if (pane) {
                const top = el.getBoundingClientRect().top - pane.getBoundingClientRect().top + pane.scrollTop;
                pane.scrollTo({ top, behavior: 'smooth' });
              } else {
                window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
              }
            }
            props.doCancelShouldScroll();
          }
        }, [v.shouldScroll]);
        return (
          // data-tour-view lets a host app address one view's section of the
          // results column without relying on its position or header text —
          // e.g. to anchor a product tour, or mount extra content into a view.
          <div key={idx} ref={divRef} data-tour-view={v.id}>
            {v.show === 'on' && <div style={{borderTopWidth:'medium'}} className='gramene-view-header'>{v.name}</div>}
            {v.show === 'on' && React.createElement(inventory[v.id], p)}
          </div>
        )
      })}
    </div>
  ) : null;
};

const Results = connect(
  'selectGrameneFilters',
  'selectGrameneViews',
  'doCancelShouldScroll',
  ResultsCmp
);

const ViewsCmp = props => (
  <div className={'gramene-view-container'}>
    <CollapsibleSection title="Views">
      {props.grameneViews.options.filter(view => view.show !== 'disabled').map((view,idx) => (
        <div style={{textWrap:'nowrap'}} key={idx}>
          <Switch onChange={()=>props.doToggleGrameneView(view.id)} checked={view.show === 'on'}
                  height={18}
                  width={30}
                  handleDiameter={16}
                  checkedIcon={false}
                  uncheckedIcon={false}
          />
          <span className={`gramene-view-span-${view.show}`} onClick={(e) => {
            props.dontToggleGrameneView(view.id)
          }}>{view.name}</span>
        </div>
      ))}
    </CollapsibleSection>
  </div>
);

const Views = connect(
  'selectGrameneViews',
  'doToggleGrameneView',
  'dontToggleGrameneView',
  ViewsCmp
);

export {Status, Filters, Facets, Results, Views, Auth};
